"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledTitle = _styledComponents["default"].h3.withConfig({
  displayName: "style__StyledTitle",
  componentId: "sc-16xly18-0"
})(["color:#393F44;font-size:16px;text-align:center;padding:20px 0 0 0;"]);

exports.StyledTitle = StyledTitle;